import { NgModule } from '@angular/core';
import { OffClickDirective } from './off-click.directive';

/**
 * @deprecated Import OffClickDirective directly0
 */
@NgModule({
    imports: [OffClickDirective],
    exports: [OffClickDirective]
})
export class OffClickModule {}
